import React from "react";

import Modals from "../popupModal/modal";

const BlockPatientModal = ({ isOpen, onSuccess, closeModal, label, type }) => {
  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title={type === "unblock" ? "Unblock Patient" : "Block Patient"}
      styles={{
        content: {
          minWidth: "552px",
          maxWidth: "552px",
          minHeight: "320px",
          maxHeight: "320px",
        },
      }}
      btnDark={{
        label: type === "unblock" ? "Unblock" : "Block",
        onclick: () => {
          onSuccess();
          closeModal();
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center denyAppointmentText">
          Are you sure you want to {type}{" "}
          <span className="text-dark">{label}</span>
        </p>
      </React.Fragment>
    </Modals>
  );
};

export default BlockPatientModal;
